module.exports = __webpack_public_path__ + "img/Layer3op.dc703916.png";